import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Producto} from '../../../modelo/producto/producto';
import {Adicional} from '../../../modelo/producto/adicional';
import {NotificacionesService} from '../../../servicios/utilidades/notificaciones.service';
import {CarritoService} from '../../../servicios/pedido/carrito.service';
import {SubscriptionLike} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
    selector: 'app-producto-template',
    templateUrl: './producto-template.component.html',
    styleUrls: ['./producto-template.component.css']
})
export class ProductoTemplateComponent implements OnInit, OnDestroy {
    @Input() producto: Producto;
    @Input() logueado: boolean;
    @Input() usuario: number = 0;
    @Input() clicodigo: string = '0';

    private subs: SubscriptionLike;

    constructor(private noti: NotificacionesService, private carService: CarritoService, private router: Router, private activeRT: ActivatedRoute) {
    }


    ngOnInit(): void {
        this.subs = null;
    }

    ngOnDestroy(): void {
        if (this.subs != null) {
            this.subs.unsubscribe();
        }
    }

    compararFuncionCondicionIva(ad: Adicional, ad2: Adicional) {
        return ad.adicional == ad2.adicional && ad.art_adicional == ad2.art_adicional;
    }

    showMensaje(mensaje: string, tipo: string) {
        let clasname: string = '';
        switch (tipo) {
            case 'error':
                clasname = 'bg-danger text-light';
                break;
            case 'exito':
                clasname = 'bg-success text-light';
                break;
            default:
                clasname = 'bg-info text-light';
                break;
        }
        this.noti.show(mensaje, {classname: clasname, delay: 5000, autohide: true});
    }

    generarURL() {
        if (this.producto.adicionalSeleccionado != null) {
            if (this.producto.adicionalSeleccionado.art_adicional.indexOf('/')) {
                return this.producto.art_codtex + '' + this.producto.art_codnum + '' + this.producto.adicionalSeleccionado.art_adicional.replace('/', '');
            }
            return this.producto.art_codtex + '' + this.producto.art_codnum + '' + this.producto.adicionalSeleccionado.art_adicional;
        }
        return this.producto.art_codtex + '' + this.producto.art_codnum;
    }

    agregarCarrito() {
        if (this.usuario != 0) {
            if (this.producto.adicionales.length > 0) {
                this.router.navigate(['/productos',this.producto.art_codtex,this.producto.art_codnum],{relativeTo:this.activeRT})
            } else {
                const adi = this.producto.adicionalSeleccionado != null ? this.producto.adicionalSeleccionado.art_adicional : '';
                this.subs = this.carService.agregarElementon(this.clicodigo, this.producto.art_codtex, this.producto.art_codnum, adi, 1, this.producto.precio,this.usuario).subscribe(res => {
                        this.showMensaje(res.status_message, 'exito');
                        this.carService.listarCantidadElementos(this.usuario.toString());
                    }, error => {
                        this.showMensaje(error.status_message, 'error');
                    }
                );
            }
        }
    }

    isMasVendido(){
      return this.producto.chips=="MÁS VENDIDO";
    }
  isNewMasVendido(){
      return this.producto.chips=="NEW,MÁS VENDIDO";
    }

  isNew(){
    return this.producto.chips.includes("NEW");
  }
  isLiquidacion(){
    return this.producto.chips=="LIQUIDACIÓN";
  }

  isProximamente(){
    return this.producto.chips=="PROXIMAMENTE";
  }

  // isBotonCompraVisible(){
  //   return (this.logueado && this.clicodigo !== '0') && (this.clicodigo !== '10780' || this.producto.precioVisible==='1');
  // }
  isBotonCompraRedirect(){
    return (this.logueado  && this.clicodigo !== '0');
  }

}
